import { createSlice } from "@reduxjs/toolkit";

const bookingReducer = createSlice({
  name: "bookingReducer",
  initialState: {
    busDetail: null,
    booking: {
      mobile: "",
      email: "",
      boarding_pass_price: "",
      travel_protection_price: "",
      passengerData: [],
    },
    activeSection: "search-buses",
    openTicketDetail: false,
    ticketActiveStep: 1,
    openPaymentProcessingModal: false,
  },
  reducers: {
    setBusDetail: (state, action) => {
      state.busDetail = action.payload;
    },
    setBooking: (state, action) => {
      state.booking = action.payload;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    setOpenTicketDetail: (state, action) => {
      state.openTicketDetail = action.payload;
    },
    setTicketActiveStep: (state, action) => {
      state.ticketActiveStep = action.payload;
    },
    resetBookingStates: (state) => {
      state.busDetail = null;
      state.booking = {
        mobile: "",
        email: "",
        boarding_pass_price: "",
        travel_protection_price: "",
        passengerData: [],
      };
      state.activeSection = "search-buses";
      state.openTicketDetail = false;
      state.ticketActiveStep = 1;
    },
    setOpenPaymentProcessModal: (state, action) => {
      state.openPaymentProcessingModal = action.payload;
    },
  },
});
export const {
  setBooking,
  setBusDetail,
  setActiveSection,
  setOpenTicketDetail,
  setTicketActiveStep,
  resetBookingStates,
  setOpenPaymentProcessModal,
} = bookingReducer.actions;
export default bookingReducer.reducer;
